import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ImageIcon from '@mui/icons-material/Image';
import { Box, Typography } from '@mui/material';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import { PopupState, bindHover, bindPopover } from 'material-ui-popup-state/hooks';
import React, { useContext } from 'react';

import { RTLDirectionContext } from '../../Layout';
import { WellnessImage } from '../Overview/DeviceDetails/WellnessPanel';

interface ReportWellnessCellProps {
    popupState: PopupState;
    isInCabinWellness: boolean;
    title: string;
    wellnessType: string;
    wellnessId: number;
}

const ReportWellnessCell: React.FC<ReportWellnessCellProps> = (props: ReportWellnessCellProps) => {
    const isRTL = useContext(RTLDirectionContext);

    return (
        <>
            <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                <Box {...bindHover(props.popupState)} sx={{ pt: 0.5, ml: -0.5, pr: 0.5 }}>
                    {props.isInCabinWellness ? <AccountBoxIcon color="primary" /> : <ImageIcon color="primary" />}
                </Box>
                <Typography variant="body2">{props.title}</Typography>
            </Box>
            <HoverPopover
                {...bindPopover(props.popupState)}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: isRTL ? 'left' : 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: isRTL ? 'right' : 'left',
                }}
            >
                <Box sx={{ width: '250px' }}>
                    <WellnessImage wellnessType={props.wellnessType} wellnessId={props.wellnessId} />
                </Box>
            </HoverPopover>
        </>
    );
};

export default ReportWellnessCell;
